import { gql } from '@apollo/client';

export const GET_NEWS_LETTER_WITH_PAGINATION = gql`
  query newsLetter_getNewsLetterWithPagination(
    $projectId: Id!
    $page: Int!
    $limit: Int!
    $templateName: String!
  ) {
    newsLetter_getNewsLetterWithPagination(
      projectId: $projectId
      page: $page
      limit: $limit
      templateName: $templateName
    ) {
      totalRows
      totalPages
      page
      limit
      result {
        id
        projectId
        titleColor
        readMoreLabel
        fontColor
        isLike
        isView
        isComment
        isEngagement
        isSentimenSocialMedia
        isPrValue
        isKeyWord
        isSentiment
        colorHeaderSection
        logoUrl
        headerImageUrl
        primaryText
        secondaryText
        footerBackgroundColor
        footerText
        instagramUrl
        twitterUrl
        tiktokUrl
        youtubeUrl
        templateName
        emailSubject
        recepientEmail
        frequentyDelivery
        timezone
        status
        deliveryDateTime
      }
    }
  }
`;

export const GET_NEWS_LETTER_DETAIL_BY_ID = gql`
  query newsLetter_getNewsLetterById($newsLetterId: Id!) {
    newsLetter_getNewsLetterById(newsLetterId: $newsLetterId) {
      newsLetter {
        id
        projectId
        titleColor
        readMoreLabel
        fontColor
        isLike
        isView
        isComment
        isEngagement
        isSentimenSocialMedia
        isPrValue
        isKeyWord
        isSentiment
        colorHeaderSection
        logoUrl
        headerImageUrl
        primaryText
        secondaryText
        footerBackgroundColor
        footerText
        instagramUrl
        twitterUrl
        tiktokUrl
        youtubeUrl
        templateName
        emailSubject
        recepientEmail
        frequentyDelivery
        timezone
        deliveryDateTime
      }
      socialMediaStream {
        id
        originalId
        source
        fromName
        displayPicture
        timestamp
        audience
        view
        like
        comment
        engagement
        title
        content
        sentiment
        keywords
        prValue
        link
        platform
      }
      onlineNewsStream {
        id
        originalId
        source
        fromName
        displayPicture
        timestamp
        audience
        view
        like
        comment
        engagement
        title
        content
        sentiment
        keywords
        prValue
        link
        platform
      }
      printStream {
        id
        originalId
        source
        fromName
        displayPicture
        timestamp
        audience
        view
        like
        comment
        engagement
        title
        content
        sentiment
        keywords
        prValue
        link
        platform
      }
      broadcastStream {
        id
        originalId
        source
        fromName
        displayPicture
        timestamp
        audience
        view
        like
        comment
        engagement
        title
        content
        sentiment
        keywords
        prValue
        link
        platform
      }
    }
  }
`;

export const GET_NEWS_LETTER_AUTOMATIC_WITH_PAGINATION = gql`
  query NewsLetter_getNewsLetterAutomaticWithPagination(
    $projectId: Id!
    $page: Int!
    $limit: Int!
    $templateName: String!
  ) {
    newsLetter_getNewsLetterAutomaticWithPagination(
      projectId: $projectId
      limit: $limit
      page: $page
      templateName: $templateName
    ) {
      totalRows
      totalPages
      page
      limit
      result {
        newsLetterAutomatic {
          id
          projectId
          titleColor
          readMoreLabel
          fontColor
          isLike
          isView
          isComment
          isEngagement
          isSentimenSocialMedia
          isPrValue
          isKeyWord
          isSentiment
          colorHeaderSection
          logoUrl
          headerImageUrl
          primaryText
          secondaryText
          footerBackgroundColor
          footerText
          instagramUrl
          twitterUrl
          tiktokUrl
          youtubeUrl
          templateName
          emailSubject
          status
          recepientEmail
          frequentyDelivery
          timezone
          deliveryDateTime
          newsLetterStart
        }
        dataSourceSocmed {
          projectId
          newsLetterAutomaticId
          objectIds
          sentiment
          postOwnership
          labels
          excludeLabels
          languageList
          includeKeywords
          excludeKeywords
          fromUsername
          startedAt
          endAt
          createdAt
          timezoneOffset
          updatedAt
          contentType
          validationList
          replyToOriginalId
          retweetFromOriginalIds
          sentimentConfidenceLevelMin
          sentimentConfidenceLevelMax
          showEmptyLabel
          retweetFilter
          talkType
          ageGeneration
          fullTextBoolOperator
          emotionList
          validationEmotionList
          userRating
        }
        dataSourceOnlineNews {
          projectId
          newsLetterAutomaticId
          startedAt
          endAt
          timezoneOffset
          updatedAt
          includeMediaList
          excludeMediaList
          includeKeywords
          excludeKeywords
          clippingId
          sentimentList
          labelList
          validationList
          languageList
          searchType
          queryStringBooleanOperator
          tier
          excludeLabels
          showEmptyLabel
        }
        dataSourcePrint {
          projectId
          newsLetterAutomaticId
          startedAt
          endAt
          timezoneOffset
          updatedAt
          includeMediaList
          excludeMediaList
          includeKeywords
          excludeKeywords
          clippingId
          sentimentList
          labelList
          validationList
          languageList
          searchType
          queryStringBooleanOperator
          tier
          excludeLabels
          showEmptyLabel
        }
        dataSourceBroadcast {
          projectId
          newsLetterAutomaticId
          startedAt
          endAt
          timezoneOffset
          updatedAt
          includeMediaList
          excludeMediaList
          includeKeywords
          excludeKeywords
          clippingId
          sentimentList
          labelList
          validationList
          languageList
          searchType
          queryStringBooleanOperator
          tier
          excludeLabels
          showEmptyLabel
          granularity {
            value
            unit
          }
        }
      }
    }
  }
`;

export const GET_NEWS_LETTER_AUTOMATIC_WITH_PAGINATION_BY_ID = gql`
  query NewsLetter_getNewsLetterAutomaticById($newsLetterAutomaticId: Id!) {
    newsLetter_getNewsLetterAutomaticById(
      newsLetterAutomaticId: $newsLetterAutomaticId
    ) {
      newsLetterAutomatic {
        id
        projectId
        titleColor
        readMoreLabel
        fontColor
        isLike
        isView
        isComment
        isEngagement
        isSentimenSocialMedia
        isPrValue
        isKeyWord
        isSentiment
        colorHeaderSection
        logoUrl
        headerImageUrl
        primaryText
        secondaryText
        footerBackgroundColor
        footerText
        instagramUrl
        twitterUrl
        tiktokUrl
        youtubeUrl
        templateName
        emailSubject
        status
        recepientEmail
        frequentyDelivery
        timezone
        deliveryDateTime
        newsLetterStart
      }
      dataSourceSocmed {
        projectId
        newsLetterAutomaticId
        objectIds
        sentiment
        postOwnership
        labels
        excludeLabels
        languageList
        includeKeywords
        excludeKeywords
        fromUsername
        startedAt
        endAt
        createdAt
        timezoneOffset
        updatedAt
        contentType
        validationList
        replyToOriginalId
        retweetFromOriginalIds
        sentimentConfidenceLevelMin
        sentimentConfidenceLevelMax
        showEmptyLabel
        retweetFilter
        talkType
        ageGeneration
        fullTextBoolOperator
        emotionList
        validationEmotionList
        userRating
      }
      dataSourceOnlineNews {
        projectId
        newsLetterAutomaticId
        startedAt
        endAt
        timezoneOffset
        updatedAt
        includeMediaList
        excludeMediaList
        includeKeywords
        excludeKeywords
        clippingId
        sentimentList
        labelList
        validationList
        languageList
        searchType
        queryStringBooleanOperator
        tier
        excludeLabels
        showEmptyLabel
        granularity {
          value
          unit
        }
      }
      dataSourcePrint {
        projectId
        newsLetterAutomaticId
        startedAt
        endAt
        timezoneOffset
        updatedAt
        includeMediaList
        excludeMediaList
        includeKeywords
        excludeKeywords
        clippingId
        sentimentList
        labelList
        validationList
        languageList
        searchType
        queryStringBooleanOperator
        tier
        excludeLabels
        showEmptyLabel
        granularity {
          value
          unit
        }
      }
      dataSourceBroadcast {
        projectId
        newsLetterAutomaticId
        startedAt
        endAt
        timezoneOffset
        updatedAt
        includeMediaList
        excludeMediaList
        includeKeywords
        excludeKeywords
        clippingId
        sentimentList
        labelList
        validationList
        languageList
        searchType
        queryStringBooleanOperator
        tier
        excludeLabels
        showEmptyLabel
        granularity {
          value
          unit
        }
      }
    }
  }
`;
